import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import axios from 'axios';
//import router from '@/router'

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
    key: 'relm',
    storage: window.localStorage,
    // Function that passes the state and returns the state with only the objects you want to store.
    reducer: (state) => ({
        consumer: state.consumer,
        //websiteSettings: state.websiteSettings,
        keenInfos: state.keenInfos,
        session: state.session
    })
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
});

const axiosConfig = {
    baseURL: process.env.VUE_APP_DATA_API_URL,
    //timeout: 8000,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};
const API = axios.create(axiosConfig);
const _ = require('lodash');

const videoProviderRegexp = new RegExp('(youtu[.]*be|vimeo)');
const youtubeIDRegexp = new RegExp('^.*(?:(?:youtu.be/|v/|vi/|u/w/|embed/)|(?:(?:watch)??v(?:i)?=|&v(?:i)?=))([^#&?]*).*');
const vimeoIDRegexp = new RegExp('^(?:https?:\\/\\/)?(?:www\\.)?(?:player\\.vimeo\\.com\\/video|vimeo\\.com)\\/(\\d+)(?:|\\/\\?)$');

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    plugins: [vuexLocalStorage.plugin],
    state: {
        loaded: false,
        loadingLabel: 'Loading',
        loadingMessage: '',

        // Website configuration
        websiteSettings: null,

        // Keen statistics
        keenInfos: {
            id: null,
            doNotTrack: false,
            hidden: false,
        },

        // Statistics session
        session: {
            id: null,
            createdAt: null
        },

        // Current RelmKey
        relmKey: null,

        // Consumer datas and available content
        consumer: null,
        articles: null,

        // Currently reading page or article
        currentArticle: null,
        currentArticleIndex: -1,
        currentPageType: null,
        currentPageTitle: null,
        currentPageDescription: null,

        showDebug: false,

        socialSharing: [
            {
                network: 'email',
                description: 'Share by Email',
                link: 'mailto:?body=URL',
                target: 'blank'
            },
            {
                network: 'linkedin',
                description: 'Share on LinkedIn',
                link: 'https://www.linkedin.com/shareArticle?mini=true&url=URL',
                windowWidth: 1020,
                windowHeight: 700
            },
            {
                network: 'twitter',
                description: 'Share on Twitter',
                link: 'http://twitter.com/share?url=URL',
                windowWidth: 420,
                windowHeight: 550
            }
        ]
    },

    // The only way to modify the state. Always synchronous.
    mutations: {
        // vuexPersist mandatory
        RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION,

        // Loading
        SET_LOADED(state, is_loaded = false) {
            state.loaded = is_loaded;
        },
        SET_LOADING_LABEL(state, label) {
            state.loadingLabel = label;
        },
        SET_LOADING_MESSAGE(state, message) {
            state.loadingMessage = message;
        },

        // Datas settings
        SET_ARTICLES(state, jsonArticles) {
            state.articles = jsonArticles;
        },
        SET_CONSUMER(state, jsonConsumer) {
            state.consumer = jsonConsumer;
            //console.log('state.relmKey: '+state.relmKey, 'state.consumer.relmKey: '+state.consumer.relmKey, 'state.consumer.sharedKey: '+state.consumer.sharedKey);
            state.consumer.isTargeted = !(state.relmKey === state.consumer.sharedKey);

            if (state.consumer.isTargeted === false) {
                state.keenInfos.sharedFrom = state.consumer.relmKey;
            }
            delete state.relmKey;
        },
        SET_WEBSITE_SETTINGS(state, jsonWebsite) {
            state.websiteSettings = jsonWebsite;
        },
        SET_RELM_KEY(state, relmKey) {
            state.relmKey = relmKey;
        },
        SET_DO_NOT_TRACK(state, enable) {
            state.keenInfos.doNotTrack = enable;
        },

        // Articles Expand
        EXPAND_ARTICLES_PRIVACY(state, params) {
            _.flatten(state.articles[params.key]).map((el) => {
                el.isPublic = params.isPublic;
                return el;
            });
        },
        EXPAND_ARTICLES_POSITION(state) {
            _.forEach(state.articles, (articleList) => {
                articleList.map((el, index) => {
                    _.flatten(el).map((el2, index2) => {
                        el2.step = index;
                        el2.order = index2;
                        el2.bj = index - (state.consumer.step - 1);
                        return el2;
                    });
                    return el;
                });
            });
        },
        EXPAND_ARTICLES_BJ_SORT(state) {
            _.forEach(state.articles, (articleList) => {
                articleList.map((el, index) => {
                    _.flatten(el).map((el2, index2) => {
                        el2.step = index;
                        el2.order = index2;
                        el2.bj = index - (state.consumer.step - 1);
                        return el2;
                    });
                    return el;
                });
            });
        },
        EXPAND_ARTICLES_PRIORITY(state) {
            state.articlesFullList = _.flatten(state.articles[0]).concat(_.flatten(state.articles[1]));
            let currentBJ = _.filter(state.articlesFullList, { 'bj': 0 });
            let laterBJ = _.filter(state.articlesFullList, function (article) {
                return article.bj > 0;
            });
            let earlierBJ = _.filter(state.articlesFullList, function (article) {
                return article.bj < 0;
            });
            state.articlesFullList = _.concat(
                _.sortBy(currentBJ, ['bj', 'isPublic', 'order']),
                _.sortBy(laterBJ, ['bj', 'isPublic', 'order']),
                _.orderBy(earlierBJ, ['bj', 'isPublic', 'order'], ['desc', 'asc', 'asc'])
            );
        },
        EXPAND_ARTICLES_VIDEO_PREVIEW(state) {
            _.filter(state.articlesFullList, function (o) {
                return o.preview.video;
            }).map((el) => {
                if (el.preview.video.youtubeUrl) {
                    el.preview.video.id = el.preview.video.youtubeUrl.match(/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|&v(?:i)?=))([^#&?]*).*/)[1];
                    el.preview.video.provider = 'youtube';
                    el.preview.video.urls = {
                        raw: 'https://img.youtube.com/vi/' + el.preview.video.id + '/maxresdefault.jpg',
                        full: 'https://img.youtube.com/vi/' + el.preview.video.id + '/hqdefault.jpg',
                        regular: 'https://img.youtube.com/vi/' + el.preview.video.id + '/mqdefault.jpg',
                        small: 'https://img.youtube.com/vi/' + el.preview.video.id + '/sddefault.jpg',
                        thumb: 'https://img.youtube.com/vi/' + el.preview.video.id + '/default.jpg'
                    };
                    //'raw': 'https://i.ytimg.com/vi_webp/' + el.preview.video.id + '/maxresdefault.webp',
                    //'full': 'https://i.ytimg.com/vi_webp/' + el.preview.video.id + '/hqdefault.webp',
                    //'regular': 'https://i.ytimg.com/vi_webp/' + el.preview.video.id + '/mqdefault.webp',
                    //'small': 'https://i.ytimg.com/vi_webp/' + el.preview.video.id + '/sddefault.webp',
                    //'thumb': 'https://i.ytimg.com/vi_webp/' + el.preview.video.id + '/default.webp'

                    // youtubeData =  'https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=' + el.preview.video.id + '&format=json';
                    // youtubeData =  'https://www.youtube.com/oembed?url=' + el.preview.video.youtubeUrl + '&format=json';
                }
            });
        },

        // Update the HTML in Article Content
        EXPAND_ARTICLES_HTML_UPDATE(state, article) {
            state.articlesFullList = article;
        },

        // Set Navigation params
        SET_CURRENT_ARTICLE(state, article) {
            state.currentArticle = article;
        },
        SET_CURRENT_ARTICLE_INDEX(state, index) {
            state.currentArticleIndex = index;
        },
        SET_CURRENT_PAGE_TYPE(state, type) {
            state.currentPageType = type;
        },
        SET_CURRENT_PAGE_TITLE(state, title) {
            state.currentPageTitle = title;
        },
        SET_CURRENT_PAGE_DESCRIPTION(state, description) {
            state.currentPageDescription = description;
        },

        // Debug
        SWITCH_SHOW_DEBUG(state) {
            state.showDebug = !state.showDebug;
        },

        // Keen ID
        SET_KEEN_ID(state, keenId) {
            state.keenInfos.id = keenId;
        },

        // Set Network where consumer came from in case of sharing
        SET_SHARED_ON(state, networkName) {
            state.keenInfos.sharedOn = networkName;
        },

        // Turn stats off for Admin view
        SET_HIDDEN(state) {
            state.keenInfos.hidden = true;
        },

        // Hide Social links
        HIDE_SOCIAL_SHARING(state) {
            state.socialSharing = [];
        },

        // Set session
        NEW_SESSION(state, id) {
            state.session.id = id;
            state.session.createdAt = new Date().toISOString();
        },
        KEEP_SESSION(state) {
            state.session.createdAt = new Date().toISOString();
        }
    },

    // Logical Processing, Can be asynchronous.
    actions: {
        loadingFeedback(context, ok = true, error = false) {
            context.commit('SET_LOADED', ok);
            context.commit('SET_LOADING_LABEL', (ok) ? `Done` : `Oops!`);
            context.commit('SET_LOADING_MESSAGE', (ok) ? `` : `Your firewall is preventing you from viewing this website.`);
            if (error !== false) {
                console.log(error);
            }
        },
        setDatas(context, json) {
            context.commit('SET_ARTICLES', json.articles);
            context.commit('SET_CONSUMER', json.consumer);
            context.dispatch('expandArticles');
            context.dispatch('loadingFeedback');
        },
        setCurrentRelmKey(context, relmKey) {
            context.commit('SET_RELM_KEY', process.env.VUE_APP_RELM_KEY || relmKey);
            context.dispatch('getDatas');
        },
        setDoNotTrack(context, enable) {
            context.commit('SET_DO_NOT_TRACK', enable);
        },
        // Add implicit properties to Articles from position
        expandArticles(context) {
            context.commit('EXPAND_ARTICLES_PRIVACY', { 'key': 0, 'isPublic': 0 });
            context.commit('EXPAND_ARTICLES_PRIVACY', { 'key': 1, 'isPublic': 1 });
            context.commit('EXPAND_ARTICLES_POSITION');
            context.commit('EXPAND_ARTICLES_BJ_SORT');
            context.commit('EXPAND_ARTICLES_PRIORITY');
            context.commit('EXPAND_ARTICLES_VIDEO_PREVIEW');
            context.dispatch('expandArticlesHtmlUpdate');
            delete context.state.articles;
        },

        // Update the HTML
        expandArticlesHtmlUpdate(context) {
            let articlesFullList = JSON.parse(JSON.stringify(context.state.articlesFullList));
            _.forEach(articlesFullList, async (article) => {
                // Parsing
                const contentDom = new DOMParser().parseFromString(article.content.trim(), 'text/html');

                // All pictures class
                contentDom.querySelectorAll('img').forEach((el) => {
                    el.parentElement.classList.add('image');
                    // Image Align
                    el.parentElement.classList.add('image-style-align-' + el.getAttribute('data-alignment'));

                });
                // Youtube fix
                contentDom.querySelectorAll('iframe').forEach((el) => {
                    let src = el.getAttribute('src');
                    const videoProvider = src.match(videoProviderRegexp)[1];
                    if (videoProvider) {
                        el.parentElement.classList.add('video');
                        el.parentElement.classList.add('video-style-align-' + el.getAttribute('data-alignment'));
                        el.setAttribute('frameborder', `0`);
                        switch (videoProvider) {
                            case 'youtube':
                            case 'youtu.be':
                                el.setAttribute('src', `https://www.youtube.com/embed/${src.match(youtubeIDRegexp)[1]}?controls=1&modestbranding=1`);
                                el.setAttribute('allow', 'accelerometer; encrypted-media; gyroscope');
                                break;
                            case 'vimeo':
                                el.setAttribute('src', `https://player.vimeo.com/video/${src.match(vimeoIDRegexp)[1]}?title=false&controls=1`);
                                break;
                        }
                    } else {
                        el.parentElement.classList.add('iframe');
                        el.parentElement.classList.add('iframe-style-align-' + el.getAttribute('data-alignment'));
                    }
                });
                // Change link Target
                contentDom.querySelectorAll('a').forEach((el) => {
                    el.setAttribute('target', '_blank');
                });
                // All element get a custom class
                contentDom.querySelectorAll('*').forEach((el) => {
                    el.classList.add('custom-' + el.tagName.toLowerCase());
                });

                // Serialize the updated content
                article.content = new XMLSerializer().serializeToString(contentDom);
            });
            context.commit('EXPAND_ARTICLES_HTML_UPDATE', articlesFullList);
        },
        async getWebsiteSettings(context) {
            if (context.state.websiteSettings === null) {
                const sellerId = process.env.VUE_APP_SELLER_ID || window.location.hostname;
                const APIRequestURL = `${process.env.VUE_APP_DATA_API_GET_WEBSITE}/${sellerId}`;

                await API.get(APIRequestURL)
                         .then((response) => {
                             // Store Datas
                             context.commit('SET_WEBSITE_SETTINGS', response.data.data);
                             return context.state.websiteSettings;
                         })
                         .catch((error) => {
                             // Error feedback
                             context.dispatch('loadingFeedback', false, error);
                             return context.state.websiteSettings;
                         });
            } else {
                return context.state.websiteSettings;
            }
        },

        async getPersonaSettings(context, persona) {
            context.commit('SET_LOADED', false);
            context.commit('SET_LOADING_LABEL', 'Loading');
            if (context.state.articles === null || context.state.relmKey != null) {
                const personaSlug = persona.persona;//'male-technology'
                const stepSlug = persona.step;//'commit-to-change'
                const APIRequestURL = `${process.env.VUE_APP_DATA_API_GET_PERSONA}/${personaSlug}/${stepSlug}`;

                await API.get(APIRequestURL)
                         .then((response) => {
                             // Store Datas
                             context.commit('SET_RELM_KEY', response.data.data.consumer.relmKey);
                             context.commit('HIDE_SOCIAL_SHARING');
                             context.commit('SET_HIDDEN', true);
                             context.dispatch('setDatas', response.data.data);
                             return true;
                         })
                         .catch((error) => {
                             // Error feedback
                             context.dispatch('loadingFeedback', false, error);
                             return false;
                         });
            } else {
                context.dispatch('loadingFeedback', true);
            }
        },
        async getDatas(context) {
            context.commit('SET_LOADED', false);
            context.commit('SET_LOADING_LABEL', 'Loading');
            if (context.state.articles === null || context.state.relmKey != null) {
                const APIRequestURL = `${process.env.VUE_APP_DATA_API_GET_ALL}/${context.state.relmKey}`;

                await API.get(APIRequestURL)
                         .then((response) => {
                             // Store Datas
                             context.dispatch('setDatas', response.data.data);
                         })
                         .catch((error) => {
                             // Error feedback
                             context.dispatch('loadingFeedback', false, error);
                         });
            } else {
                context.dispatch('loadingFeedback', true);
            }
        },
        getMetas(context) {
            return {
                websiteSettings: context.state.websiteSettings,
                articles: context.state.articlesFullList
            };
        },
        getLogo(context) {
            return context.state.websiteSettings.styles.imageLogo;
        },
        getArticleById(context, articleId) {
            if (typeof articleId === 'string') {
                articleId = parseInt(articleId);
            }
            return _.find(context.state.articlesFullList, { 'id': articleId });
        },
        getArticleBySlug(context, articleSlug) {
            if (typeof articleSlug === 'string') {
                articleSlug = parseInt(articleSlug);
            }
            return _.find(context.state.articlesFullList, { 'slug': articleSlug });
        },
        clearCurrentArticle(context) {
            context.commit('SET_CURRENT_ARTICLE', null);
            context.commit('SET_CURRENT_ARTICLE_INDEX', null);
            context.commit('SET_CURRENT_PAGE_TYPE', null);
            context.commit('SET_CURRENT_PAGE_TITLE', null);
            context.commit('SET_CURRENT_PAGE_DESCRIPTION', null);
        },
        setCurrentPageType(context, type) {
            context.commit('SET_CURRENT_PAGE_TYPE', type);
        },
        setCurrentPageTitle(context, title) {
            context.commit('SET_CURRENT_PAGE_TITLE', title);
        },
        setCurrentPageDescription(context, description) {
            context.commit('SET_CURRENT_PAGE_DESCRIPTION', description);
        },
        setCurrentArticleById(context, articleId) {
            if (typeof articleId === 'string') {
                articleId = parseInt(articleId);
            }
            context.commit('SET_CURRENT_ARTICLE', _.find(context.state.articlesFullList, { 'id': articleId }));
            context.commit('SET_CURRENT_ARTICLE_INDEX', _.findIndex(context.state.articlesFullList, { 'id': articleId }));
            context.commit('SET_CURRENT_PAGE_TYPE', 'article');
            context.commit('SET_CURRENT_PAGE_TITLE', _.find(context.state.articlesFullList, { 'id': articleId }).title);
        },
        setCurrentArticleBySlug(context, slug) {
            context.commit('SET_CURRENT_ARTICLE', _.find(context.state.articlesFullList, { 'slug': slug }));
            context.commit('SET_CURRENT_ARTICLE_INDEX', _.findIndex(context.state.articlesFullList, { 'slug': slug }));
            context.commit('SET_CURRENT_PAGE_TYPE', 'article');
            context.commit('SET_CURRENT_PAGE_TITLE', _.find(context.state.articlesFullList, { 'slug': slug }).title);
        },
        setKeenId(context, keenId) {
            context.commit('SET_KEEN_ID', keenId);
        },
        setSharedOn(context, networkName) {
            context.commit('SET_SHARED_ON', networkName);
        },
        setHidden(context) {
            context.commit('SET_HIDDEN');
        },
        newSession(context, id) {
            context.commit('NEW_SESSION', id);
        },
        keepSession(context) {
            context.commit('KEEP_SESSION');
        }
    }
});
